import React from "react";
import { ShieldCheck, Lock, MapPin } from "lucide-react";
import { useI18n } from "@/i18n";

export function TrustBar() {
  const { t } = useI18n();
  const items = [
    { icon: ShieldCheck, h: t("trust_1_h"), b: t("trust_1_b") },
    { icon: Lock, h: t("trust_2_h"), b: t("trust_2_b") },
    { icon: MapPin, h: t("trust_3_h"), b: t("trust_3_b") },
  ];
  return (
    <div data-testid="trust-bar" className="grid grid-cols-1 md:grid-cols-3 gap-6 rounded-2xl bg-white/70 backdrop-blur border border-white/60 card-shadow px-6 py-5">
      {items.map((it, i) => (
        <div key={i} className="flex items-start gap-3">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-teal-50 text-brandteal">
            <it.icon className="h-5 w-5" />
          </div>
          <div>
            <p className="text-sm font-semibold text-navy">{it.h}</p>
            <p className="text-sm text-slate-500">{it.b}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
